<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Merchant"
              bc1="App"
              bc2="Report"
              bc3="Generate"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Generate Report</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Type</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <select
                                  class="form-control"
                                  v-model="type"
                              >
                                <option
                                    :key="typeIndex"
                                    :value="typeVal.value"
                                    v-for="(typeVal, typeIndex) in typeList"
                                >
                                  {{typeVal.label}}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12" v-if="showSettlementDropdown && type != 'euronetDccReport'">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Settlement</label>
                          </div>
                          <div class="col-sm-9">
                            <InfiniteSelect
                                api-url="v1/get-settlement"
                                ref="settlementInfiniteSelect"
                                :request-params="requestParams"
                                :formatter="customSettlementNameForMultiselect"
                                key-field="id"
                                @selectedFullObj="(item) => selectedSettlement = item"
                                placeholder-text="Select a settlement..."
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-12" v-if="type == 'vat' || type == 'storeSettlementReport'">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Store</label>
                          </div>
                          <div class="col-sm-9">
                            <InfiniteSelect
                                api-url="v1/get-store"
                                ref="storeInfiniteSelect"
                                :request-params="storeRequestParams"
                                :formatter="(obj) => obj.name + '/' + obj.code"
                                key-field="id"
                                @selectedFullObj="(item) => selectedStore = item"
                                placeholder-text="Select a store..."
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-12" v-if="type == 'vat' || type == 'extraMilesSplitReport' ">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Month</label>
                          </div>
                          <div class="col-sm-9">
                            <date-picker
                                v-model="month"
                                type="month"
                                format="MMM YYYY"
                                valueType="format"
                                valueFormat="YYYY-MM"
                                :disabledDate="(date) => disableFutureMonths(date, type === 'extraMilesSplitReport')"
                                :lang="lang"
                                name="month"
                                placeholder="Choose month"
                                class="w-100"
                            />
                            <input type="hidden" name="month" v-validate="'required'" v-model="month">
                            <small
                                v-show="errorBag.has('month')"
                                class="text-danger"
                            >{{ "*" + errorBag.first("month") }}</small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12" v-if="type == 'euronetDccReport' || type == 'storeSettlementReport'">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>From Date</label>
                          </div>
                          <div class="col-sm-9">
                            <date-picker
                                v-model="fromDate"
                                valueType="format"
                                :disabledDate="disableFutureDates"
                                :lang="lang"
                                name="fromDate"
                                placeholder="Choose start date"
                                class="w-100"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-12" v-if="type == 'euronetDccReport' || type == 'storeSettlementReport'">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>To Date</label>
                          </div>
                          <div class="col-sm-9">
                            <date-picker
                                v-model="toDate"
                                :disabledDate="disableFutureDates"
                                valueType="format"
                                :lang="lang"
                                name="toDate"
                                placeholder="Choose end date"
                                class="w-100"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-9 offset-sm-3">
                        <button
                            @click="generateReport"
                            type="button"
                            class="btn btn-primary mr-1 d-flex"
                            :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Generate
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>


  </div>
  <!-- END: Content-->
</template>


<script>

import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/index.css';
import InfiniteSelect from "@/components/common/InfiniteSelect.vue";
import merchantReportMixin from "@/pages/dashboard/merchant-report/merchantReportMixin";

export default {
  components: {
    InfiniteSelect,
    DatePicker
  },
  mounted() {
  },
  mixins: [merchantReportMixin],
  data() {
    return {
      size: "10px",
      loading: false,
    }
  },
  methods: {
    customSettlementNameForMultiselect (item) {
      return `${item.uuid}/${item.user_account.user.email}`
    },
    generateReport() {
      this.$validator.validateAll().then(valid => {
        if(valid){
          this.loading = true
          let data = {
            type: this.type,
          }

          if(this.selectedSettlement){
            data.typeId = this.selectedSettlement.id
          }


          if(this.type == 'vat'){
            if(this.selectedStore){
              data.typeId = this.selectedStore.id
            }
          }

          if(this.type == 'vat' || this.type == 'extraMilesSplitReport'){
            data.period = this.getRequestMonth(this.month)
          }

          if(this.type == 'euronetDccReport'){
            data.fromDate = this.fromDate
            data.toDate = this.toDate
          }

          if(this.type == 'storeSettlementReport'){
            if(this.selectedStore){
              data.typeId = this.selectedStore.id
            }
            data.fromDate = this.fromDate
            data.toDate = this.toDate
          }

          this.makeRequest("post", "v1/merchant-report", data).then(
              (callResponse) => {
                this.loading = false
                if (!callResponse.error) {
                  let code = callResponse.response.data.code;
                  let responseData = callResponse.response.data.data;
                  if (code == 200) {
                    this.$router.push({name: 'merchant-reports'})
                  }
                }
              }
          );
        }
      })
    },
  },
}
</script>

